import { TimeRange } from './clamp-range-to-bounds';

export type FixedDurationAnchor = 'start' | 'center';

/**
 * Fits a fixed-duration time window inside the given bounds.
 * The window is either anchored at its start (anchorTs = from) or centered (anchorTs = center).
 * If the desired window fits in bounds, it is returned as-is. Otherwise it is shifted so it
 * stays enclosed; if bounds are shorter than duration, returns the full bounds.
 * All values are in milliseconds.
 */
export function fitFixedDurationInBounds(
  anchorTs: number,
  durationMs: number,
  bounds: TimeRange,
  anchor: FixedDurationAnchor,
): TimeRange {
  const { from: rangeFrom, to: rangeTo } = bounds;
  if (durationMs >= rangeTo - rangeFrom) {
    return { from: rangeFrom, to: rangeTo };
  }

  const desiredFrom = anchor === 'start' ? anchorTs : anchorTs - durationMs / 2;
  const maxFrom = rangeTo - durationMs;
  const from = Math.max(rangeFrom, Math.min(desiredFrom, maxFrom));
  return { from, to: from + durationMs };
}
